// Import style
import './style.scss';

// Import dependencies
import isDefined from '@automator/utilities/is-defined';

/**
 * Hide an element using the fade in effect
 *
 * @param {Node}     $element The element to fade
 * @param {Callback} callback The function invoked once the fade is completed
 * @return {undefined}
 */
const fadeOut = ( $element, callback ) => {
	// Show the element
	$element.style.display = 'block';

	// Set opacity to 1
	$element.style.opacity = '1';

	setTimeout( () => {
		// Set the opacity to 0
		$element.style.opacity = '0';

		// Add the class
		$element.classList.add( 'uap-fade-out' );

		// Wait for the animation to end
		setTimeout( () => {
			// Hide the element
			$element.style.display = 'none';

			// Remove the class
			$element.classList.remove( 'uap-fade-out' );

			// Invoke the callback
			if ( isDefined( callback ) ) {
				callback();
			}
		}, 150 );
	}, 10 );
};

export default fadeOut;
